import { useForm } from "react-hook-form";
import { useLocation, useNavigate } from "react-router-dom";
import usePopup from "../../hooks/usePopup";
import { useMutation } from "react-query";
import { useEffect } from "react";
import { Button, CircularProgress, Divider, Paper, Typography } from "@mui/material";
import { ArrowBack, Close, Save } from "@mui/icons-material";
import { CustomFormField } from "../../utilis/component/CustomFormElement";
import { editPostOficeType, PostOfficeListType } from "./types";
import { editPostOfficeService } from "./Service";
import { clinicId } from "../../constants";


function AddOrEditPage() {
 const pageTitle="Post Office"
  const navigate = useNavigate();
  const { control, handleSubmit, reset } = useForm<editPostOficeType>({
    defaultValues:{
                    poName: "",
                    poUserName: "",
                    poClinicLicense: "",
                    poLink: "",
                    poPassword: "",
                    poUpLink: ""
    }
  });
  const {
    state: { data=null },
  } = useLocation()  as { state: { data: PostOfficeListType } };
  const { showSnackbar } = usePopup();
    const handleGoBack = () => {
    navigate(-1);
  };
  const { mutate: editPostOffice, isLoading } = useMutation(editPostOfficeService, {
    onSuccess: (result) => {
      if (result.responseIndicator == "success") {
        showSnackbar({
          message: result.responseMessage,
          open: true,
          variant: "success",
          duration: 3000,
        });
        handleGoBack()
      } else {
        showSnackbar({
          message: result.responseMessage,
          open: true,
          variant: "warning",
          duration: 3000,
        });
      }
    },
    onError: (e: any) => {
      showSnackbar({
        message: e?.response?.data?.responseMessage || "Something went wrong !",
        open: true,
        variant: "error",
        duration: 3000,
      });
    },
  });
  const onSubmit = (value: editPostOficeType) => {
    
    editPostOffice({
        poId:Number(data?.poId),
        poName: value.poName,
        poUserName: value.poUserName,
        poClinicLicense: value.poClinicLicense,
        poLink: value.poLink,
        poPassword: value.poPassword,
        poUpLink: value.poUpLink,
        clinicId: Number(clinicId)
    });
  };


  useEffect(() => {
    if (data) {
      reset({
        poName:data.poName,
        poUserName: data.poUserName,
        poClinicLicense: data.poClinicLicense,
        poLink: data.poLink,
        poPassword: data.poPassword ,
        poUpLink: data.uplink
      });
    }
  }, [data]);

  return (
    <div className="p-3">
      <form onSubmit={handleSubmit(onSubmit)}>
        <Paper>
          <div className="flex justify-between items-center p-2">
            <div>
              <Typography variant="h6" className="p-3">
                Add {pageTitle}
              </Typography>
            </div>
            <div className="flex gap-2">
              <Button
                variant="outlined"
                startIcon={<ArrowBack/>}
                onClick={handleGoBack}
              >
                back
              </Button>
              <Button
                disabled={isLoading}
                color="error"
                onClick={()=>reset({
                    poName: "",
                    poUserName: "",
                    poClinicLicense: "",
                    poLink: "",
                    poPassword: "",
                    poUpLink: ""
                })}
                startIcon={<Close/>}
              >
                reset
              </Button>
              <Button
                disabled={isLoading}
                type="submit"
                color="success"
                startIcon={
                  isLoading ? (
                    <CircularProgress size={20} color="success" />
                  ) : (
                    <Save/>
                  )
                }
              >
                save
              </Button>
            </div>
          </div>
          <Divider />
          <div className="p-3 grid grid-cols-4 gap-3">
            <CustomFormField
              control={control}
              name="poName"
              element="input"
              fieldProps={{ label: "enter postOffice Name " }}
              rules={{ required: "postOffice Name required" }}
            />
            <CustomFormField
              control={control}
              name="poUserName"
              element="input"
              fieldProps={{ label: "Enter UserName " }}
              rules={{ required: "UserName is required" }}
            />
            <CustomFormField
              control={control}
              name="poPassword"
              element="input"
              fieldProps={{ label: "Enter Password",type: "password" }}
              rules={{ required:"password is required"}}
            />
       
              <CustomFormField
                control={control}
                name="poClinicLicense"
                element="input"
                fieldProps={{ label: "Enter license Code " }}
                rules={{ required: "license Code required" }}
              />
              <CustomFormField
                control={control}
                name="poLink"
                element="input"
                fieldProps={{ label: "Enter postOffice URL " }}
                rules={{ required: "postOffice URL is Required" }}
              />
          </div>
        </Paper>
      </form>
    </div>
  );
}
export default AddOrEditPage
